module.exports = __webpack_public_path__ + "resources/com-status-empty.de0a232dc4db0a7c.png";